import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditUsersReportTable from "../components/Users";

export default function AuditUsersReport() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('Users report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditUsersReportTable />
        </Layout>
    )
}